import { timeout } from "./AppConstants";

export const MAX_COUNT = 40;

export enum CheckTransactionOutput {
  initial = "Initial state",
  noTonClient = "TON Client not found",
  noCodeVersion = "Sale Code version not found",
  noCurrentTransaction = "Current transaction not found",
  noCurrentTransactionBody = "Current transaction body not found",
  nonPurchaseTransaction = "Operation code is not purchase",
  queryIdNotMatched = "Blockchain query id is not matched",
  errorCatched = "Error catched",
  success = "success",
}

export const checkWhileTransaction = async (
  transactionCheckCallback: () => Promise<CheckTransactionOutput>,
  successCallback: () => Promise<unknown>
) => {
  let lastResult = CheckTransactionOutput.initial;
  let lastTryIndex = 0;
  while (lastTryIndex < MAX_COUNT) {
    lastResult = await transactionCheckCallback();
    if (lastResult === CheckTransactionOutput.success) {
      break;
    }

    await timeout(3000);

    lastTryIndex += 1;
  }
  if (lastResult === CheckTransactionOutput.success) {
    await successCallback();
  }
};
